<div class="mobi-ui-padding-t-lg">
    <oiv-viewer-sidenav [sidenavItems]="sidenavItems()" (navigationClick)="closeOverlay()" />
</div>
